var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22656 9.7499C7.8697 11.078 8.94366 12.1492 10.2734 12.789C10.3715 12.8354 10.48 12.8555 10.5882 12.8473C10.6965 12.8391 10.8007 12.8028 10.8906 12.7421L12.8437 11.4374C12.93 11.3789 13.0298 11.3432 13.1336 11.3336C13.2374 11.324 13.342 11.3409 13.4375 11.3827L17.0938 12.953C17.2187 13.005 17.3231 13.0967 17.3909 13.2139C17.4586 13.331 17.486 13.4672 17.4688 13.6015C17.3529 14.5059 16.9114 15.3372 16.2269 15.9397C15.5424 16.5422 14.6619 16.8747 13.75 16.8749C10.9321 16.8749 8.22956 15.7555 6.23699 13.7629C4.24442 11.7703 3.125 9.06783 3.125 6.2499C3.12521 5.33803 3.45767 4.45747 4.06018 3.77299C4.66269 3.08852 5.49395 2.64704 6.39844 2.53115C6.53269 2.51391 6.66888 2.54127 6.78605 2.60903C6.90322 2.67679 6.99487 2.78119 7.04687 2.90615L8.61719 6.57022C8.65802 6.66424 8.67511 6.76686 8.66693 6.86904C8.65876 6.97122 8.62558 7.06982 8.57031 7.15615L7.26562 9.14053C7.20754 9.23028 7.17345 9.33343 7.16661 9.44012C7.15977 9.54681 7.18041 9.65347 7.22656 9.7499V9.7499Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/iconPhone.b117176d629260940e6fefe04abc0c38.svg";
export { ForwardRef as ReactComponent };